import PropTypes from 'prop-types';
import React from 'react';
import { formValues } from 'redux-form';
import { IntegerField } from 'components/form/field';
import { HorizontalLayout } from 'components/form/layout';
import { subscription as computeAmountSubscription } from 'common/model/summary/cappedReductions';
import { OwnerField } from '../field';
import Recurrent from '../Recurrent';
import DisabledTaxField from './DisabledTaxField';

const SubscriptionReduction = ({ name, familySituation }) => (
    <HorizontalLayout>
        <OwnerField name={`${name}.fiscalHome`} title="Concubin concerné" onlyCohabitation required single />
        <IntegerField name={`${name}.amount`} title="Montant annuel de la souscription" required />
        <Recurrent name={name} />
        <DisabledTaxField
            name={name}
            computeAmount={computeAmountSubscription({ familySituation })}
            type="reduction"
            path="computedAmount"
        />
    </HorizontalLayout>
);

SubscriptionReduction.propTypes = {
    name: PropTypes.string.isRequired,
    familySituation: PropTypes.string.isRequired,
};

export default formValues('familySituation')(SubscriptionReduction);
